import React, {
  useState,
  useRef,
  useEffect,
  useCallback,
  forwardRef,
  useImperativeHandle,
} from "react";
import { Link2, Check, X, Share2, Mail, MessageCircle } from "lucide-react";

const APPS = [
  {
    id: "whatsapp",
    label: "واتساپ",
    color: "#25D366",
    Icon: (props) => (
      <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
        <path d="M17.47 14.38c-.29-.15-1.7-.84-1.96-.93-.26-.1-.46-.15-.65.15-.2.29-.75.93-.92 1.12-.17.2-.34.22-.63.08-.29-.15-1.22-.45-2.32-1.43-.86-.76-1.44-1.71-1.6-2-.17-.29-.02-.45.13-.6.13-.13.29-.34.44-.51.15-.17.2-.29.29-.48.1-.2.05-.37-.02-.51-.08-.15-.65-1.57-.9-2.15-.24-.58-.48-.5-.65-.5-.17-.01-.37-.01-.56-.01-.2 0-.51.07-.78.37-.26.29-1.02 1-1.02 2.44s1.05 2.83 1.19 3.03c.15.2 2.06 3.15 5 4.42.7.3 1.24.48 1.67.61.7.22 1.34.19 1.84.12.56-.08 1.7-.7 1.94-1.37.24-.68.24-1.25.17-1.37-.07-.12-.26-.2-.55-.34z" />
        <path d="M12.02 2C6.5 2 2 6.48 2 12c0 1.87.51 3.63 1.4 5.14L2 22l5-1.35A9.95 9.95 0 0 0 12.02 22C17.55 22 22 17.52 22 12S17.55 2 12.02 2zm0 18.13c-1.69 0-3.27-.47-4.62-1.29l-.33-.2-3.05.82.82-2.97-.21-.31A8.13 8.13 0 0 1 3.87 12c0-4.5 3.66-8.13 8.15-8.13 4.48 0 8.13 3.63 8.13 8.13 0 4.5-3.65 8.13-8.13 8.13z" />
      </svg>
    ),
    getHref: ({ shareText }) =>
      `https://wa.me/?text=${encodeURIComponent(shareText)}`,
  },
  {
    id: "telegram",
    label: "تلگرام",
    color: "#26A5E4",
    Icon: (props) => (
      <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
        <path d="M21.5 3.5 2.9 10.8c-1.2.5-1.2 1.2-.2 1.5l4.8 1.5 1.8 5.5c.2.6.4.8.8.8.4 0 .6-.2.9-.5l2.1-2 4.4 3.2c.8.5 1.4.2 1.6-.7l3-14.1c.3-1.1-.4-1.6-1.4-1.5zM8.7 14.1l9.5-6c.4-.3.8-.1.5.2l-7.9 7.1-.3 3.3-1.4-4.6z" />
      </svg>
    ),
    getHref: ({ shareText }) =>
      `https://t.me/share/url?url=&text=${encodeURIComponent(shareText)}`,
  },
  {
    id: "bale",
    label: "بله",
    color: "#08ca9b",
    Icon: (props) => (
      <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
        <path d="M12 2C6.48 2 2 6.02 2 11c0 2.83 1.45 5.35 3.72 7.02-.12.9-.46 2.36-1.28 3.6-.1.15.03.33.2.3 1.85-.36 3.35-1.28 4.14-1.87A11.6 11.6 0 0 0 12 20c5.52 0 10-4.02 10-9s-4.48-9-10-9zm-3.6 11.1a1.1 1.1 0 1 1 0-2.2 1.1 1.1 0 0 1 0 2.2zm3.6 0a1.1 1.1 0 1 1 0-2.2 1.1 1.1 0 0 1 0 2.2zm3.6 0a1.1 1.1 0 1 1 0-2.2 1.1 1.1 0 0 1 0 2.2z" />
      </svg>
    ),
    getHref: ({ shareText }) =>
      `https://ble.ir/share/url?text=${encodeURIComponent(shareText)}`,
  },
  {
    id: "eitaa",
    label: "ایتا",
    color: "#ed7d1f",
    Icon: (props) => (
      <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
        <path d="M21.5 3.5 2.9 10.8c-1.2.5-1.2 1.2-.2 1.5l4.8 1.5 1.8 5.5c.2.6.4.8.8.8.4 0 .6-.2.9-.5l2.1-2 4.4 3.2c.8.5 1.4.2 1.6-.7l3-14.1c.3-1.1-.4-1.6-1.4-1.5zM8.7 14.1l9.5-6c.4-.3.8-.1.5.2l-7.9 7.1-.3 3.3-1.4-4.6z" />
      </svg>
    ),
    getHref: ({ shareText }) =>
      `https://eitaa.com/share/url?text=${encodeURIComponent(shareText)}`,
  },
  {
    id: "email",
    label: "ایمیل",
    color: "#6B7280",
    Icon: Mail,
    getHref: ({ title, shareText }) =>
      `mailto:?subject=${encodeURIComponent(title)}&body=${encodeURIComponent(shareText)}`,
  },
  {
    id: "sms",
    label: "پیامک",
    color: "#22C55E",
    Icon: MessageCircle,
    getHref: ({ shareText }) => `sms:?body=${encodeURIComponent(shareText)}`,
  },
];

/**
 * ShareButton
 *
 *   const shareRef = useRef();
 *   shareRef.current.openShare();   // باز کردن پاپ‌آپ اشتراک‌گذاری
 *   shareRef.current.closeShare();  // بستن پاپ‌آپ
 *
 * با پراپ hideTrigger می‌توان دکمهٔ ظاهری «اشتراک‌گذاری» را مخفی کرد و فقط
 * استفاده کرد؛
 */
const ShareButton = forwardRef(function ShareButton(
  {
    text = "",
    title = "اشتراک‌گذاری",
    iconOnly = false,
    className = "",
    variant = "filled",
    hideTrigger = false,
    onOpenChange,
  },
  ref
) {
  const [open, setOpen] = useState(false);
  const [copied, setCopied] = useState(false);
  const containerRef = useRef(null);

  const shareData = { title, shareText: text };

  const updateOpen = useCallback(
    (value) => {
      setOpen(value);
      onOpenChange?.(value);
    },
    [onOpenChange]
  );

  useImperativeHandle(ref, () => ({
    openShare: () => updateOpen(true),
    closeShare: () => updateOpen(false),
    toggleShare: () => updateOpen(!open),
  }));

  useEffect(() => {
    if (!open) return;
    const onClickOutside = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        updateOpen(false);
      }
    };
    const onEsc = (e) => e.key === "Escape" && updateOpen(false);
    document.addEventListener("mousedown", onClickOutside);
    document.addEventListener("keydown", onEsc);
    return () => {
      document.removeEventListener("mousedown", onClickOutside);
      document.removeEventListener("keydown", onEsc);
    };
  }, [open, updateOpen]);

  const handleCopy = useCallback(async () => {
    try {
      await navigator.clipboard.writeText(text);
    } catch {
      const el = document.createElement("textarea");
      el.value = text;
      el.style.position = "fixed";
      el.style.opacity = "0";
      document.body.appendChild(el);
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
    }
    setCopied(true);
    setTimeout(() => setCopied(false), 1800);
  }, [text]);

  const isGhost = variant === "ghost";

  const baseButtonClasses = isGhost
    ? "group inline-flex items-center gap-2 rounded-full text-sm font-medium text-slate-700 transition-all hover:text-primary active:scale-95 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 dark:text-slate-200 dark:hover:text-primary"
    : "group inline-flex items-center gap-2 rounded-full border border-slate-200 bg-white text-sm font-medium text-slate-700 shadow-sm transition-all hover:border-slate-300 hover:shadow-md active:scale-95 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-200 dark:hover:border-slate-600";

  return (
    <div
      className={`relative inline-block ${className}`}
      ref={containerRef}
      onClick={(e) => e.stopPropagation()}
    >
      {!hideTrigger && (
        <button
          type="button"
          onClick={() => updateOpen(!open)}
          aria-expanded={open}
          aria-haspopup="dialog"
          className={`${baseButtonClasses} ${
            iconOnly
              ? "h-10 w-10 justify-center p-0"
              : isGhost
                ? "px-1 py-1"
                : "px-4 py-2.5"
          }`}
          aria-label="اشتراک‌گذاری"
        >
          <Share2 className="h-4 w-4 text-primary transition-transform group-hover:-rotate-12" />
          {!iconOnly && "اشتراک‌گذاری"}
        </button>
      )}

      {open && (
        <>
          {/* بک‌دراپ برای موبایل */}
          <div
            className="fixed inset-0 z-[99998] bg-slate-900/20 backdrop-blur-[2px] sm:hidden"
            onClick={() => updateOpen(false)}
          />

          <div
            role="dialog"
            aria-label="اشتراک‌گذاری"
            className="
              fixed inset-x-4 bottom-4 z-[99999] origin-bottom
              animate-[slideUp_.22s_ease-out]
              sm:absolute sm:inset-auto sm:bottom-auto sm:top-full sm:mt-3
              sm:right-0 sm:w-80 sm:origin-top-right sm:animate-[popIn_.16s_ease-out]
            "
          >
            <div className="overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-xl shadow-slate-900/10 dark:border-slate-700 dark:bg-slate-900">
              <div className="flex items-center justify-between border-b border-slate-100 px-4 py-3 dark:border-slate-800">
                <p className="truncate text-sm font-semibold text-slate-800 dark:text-slate-100">
                  {title}
                </p>
                <button
                  onClick={() => updateOpen(false)}
                  className="rounded-full p-1 text-slate-400 transition-colors hover:bg-slate-100 hover:text-slate-600 dark:hover:bg-slate-800"
                  aria-label="بستن"
                >
                  <X className="h-4 w-4" />
                </button>
              </div>

              <div className="grid grid-cols-4 gap-x-2 gap-y-4 px-4 pb-4 pt-4">
                {APPS.map(({ id, label, color, Icon, getHref }, i) => (
                  <a
                    key={id}
                    href={getHref(shareData)}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="group flex flex-col items-center gap-1.5 opacity-0 [animation-fill-mode:forwards]"
                    style={{
                      animation: `fadeUp .3s ease-out forwards`,
                      animationDelay: `${i * 35}ms`,
                    }}
                  >
                    <span
                      className="flex h-11 w-11 items-center justify-center rounded-full text-white shadow-sm transition-transform duration-150 group-hover:scale-110 group-active:scale-95"
                      style={{ backgroundColor: color }}
                    >
                      <Icon className="h-5 w-5" />
                    </span>
                    <span className="text-[11px] text-slate-600 dark:text-slate-300">
                      {label}
                    </span>
                  </a>
                ))}
              </div>

              <div className="border-t border-slate-100 p-3 dark:border-slate-800">
                <button
                  onClick={handleCopy}
                  className="flex w-full items-center gap-2.5 rounded-xl border border-slate-200 bg-slate-50 px-3 py-2.5 text-right transition-colors hover:bg-slate-100 dark:border-slate-700 dark:bg-slate-800/60 dark:hover:bg-slate-800"
                >
                  <span
                    className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-colors ${
                      copied ? "bg-emerald-500" : "bg-primary"
                    }`}
                  >
                    {copied ? (
                      <Check className="h-4 w-4 text-white" />
                    ) : (
                      <Link2 className="h-4 w-4 text-white" />
                    )}
                  </span>
                  <span className="min-w-0 flex-1">
                    <span className="block text-xs font-medium text-slate-700 dark:text-slate-200">
                      {copied ? "متن کپی شد!" : "کپی متن"}
                    </span>
                    <span className="block truncate text-[11px] text-slate-400 dark:text-slate-500">
                      {text}
                    </span>
                  </span>
                </button>
              </div>
            </div>
          </div>
        </>
      )}

      <style>{`
        @keyframes fadeUp {
          from { opacity: 0; transform: translateY(6px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        @keyframes popIn {
          from { opacity: 0; transform: scale(.95) translateY(-4px); }
          to   { opacity: 1; transform: scale(1) translateY(0); }
        }
        @keyframes slideUp {
          from { opacity: 0; transform: translateY(16px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        @media (prefers-reduced-motion: reduce) {
          [style*="animation"] { animation: none !important; opacity: 1 !important; }
        }
      `}</style>
    </div>
  );
});

export default ShareButton;
